import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getHealthChecks,
  getHealthCheckMetrics,
  getBrandsForFilter,
  getLocationsForFilter,
} from 'actions/index';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import HealthChecksView from './HealthChecksView';

class HealthChecksContainer extends Component {
  componentDidMount() {
    const { fetchBrands, fetchLocationsForFilter, location } = this.props;
    const queryParams = location?.search ? queryString.parse(location.search) : {};
    fetchBrands();
    fetchLocationsForFilter(queryParams.brand_id ? { brands: [queryParams.brand_id] } : {});
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const prevSearch = prevProps.location?.search || '';
    const search = location?.search || '';
    if (prevSearch !== search) {
      const queryParams = location?.search ? queryString.parse(location.search) : {};
      if (
        queryParams.brand_id !==
        (prevProps.location?.search ? queryString.parse(prevProps.location.search) : {}).brand_id
      ) {
        this.props.fetchLocationsForFilter(
          queryParams.brand_id ? { brands: [queryParams.brand_id] } : {},
        );
      }
      this.fetchListOnly();
    }
  }

  fetchData = () => {
    const { fetchHealthChecks, fetchMetrics, location } = this.props;
    const queryParams = location?.search ? queryString.parse(location.search) : {};
    const limit = Number(queryParams.limit) || 10;
    const offset = Number(queryParams.offset) || 0;
    const brand_id = queryParams.brand_id || undefined;
    const location_id = queryParams.location_id || undefined;
    const overall_status = queryParams.overall_status || undefined;
    const device_type = queryParams.device_type || undefined;
    const search = (queryParams.search || '').trim() || undefined;

    fetchHealthChecks({
      limit,
      offset,
      brand_id,
      location_id,
      overall_status,
      device_type,
      search,
    });
    fetchMetrics({ brand_id, location_id });
  };

  fetchListOnly = () => {
    const { fetchHealthChecks, location } = this.props;
    const queryParams = location?.search ? queryString.parse(location.search) : {};
    const limit = Number(queryParams.limit) || 10;
    const offset = Number(queryParams.offset) || 0;
    const brand_id = queryParams.brand_id || undefined;
    const location_id = queryParams.location_id || undefined;
    const overall_status = queryParams.overall_status || undefined;
    const device_type = queryParams.device_type || undefined;
    const search = (queryParams.search || '').trim() || undefined;

    fetchHealthChecks({
      limit,
      offset,
      brand_id,
      location_id,
      overall_status,
      device_type,
      search,
    });
  };

  render() {
    const {
      list,
      metrics,
      loading,
      metricsLoading,
      pagination,
      fetchHealthChecks,
      fetchLocationsForFilter,
      location,
      brands,
      locations,
    } = this.props;

    const queryParams = location?.search ? queryString.parse(location.search) : {};

    return (
      <HealthChecksView
        list={list}
        metrics={metrics}
        loading={loading}
        metricsLoading={metricsLoading}
        pagination={pagination}
        fetchHealthChecks={fetchHealthChecks}
        fetchLocationsForFilter={fetchLocationsForFilter}
        location={location}
        brands={brands}
        locations={locations}
        initialBrandId={queryParams.brand_id || ''}
        initialLocationId={queryParams.location_id || ''}
        initialOverallStatus={queryParams.overall_status || ''}
      />
    );
  }
}

HealthChecksContainer.propTypes = {
  brands: PropTypes.array.isRequired,
  fetchBrands: PropTypes.func.isRequired,
  fetchHealthChecks: PropTypes.func.isRequired,
  fetchLocationsForFilter: PropTypes.func.isRequired,
  fetchMetrics: PropTypes.func.isRequired,
  list: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.object,
  locations: PropTypes.array.isRequired,
  metrics: PropTypes.object,
  metricsLoading: PropTypes.bool.isRequired,
  pagination: PropTypes.object.isRequired,
};

const MAX_LOCATION_LABEL_LENGTH = 40;

function truncateLabel(label, maxLen = MAX_LOCATION_LABEL_LENGTH) {
  if (!label || typeof label !== 'string') return label || '';
  const trimmed = label.trim();
  if (trimmed.length <= maxLen) return trimmed;
  return `${trimmed.slice(0, maxLen)}…`;
}

function mapStateToProps(state) {
  const brandsList = state.brands.listForFilter || [];
  const sortedBrands = [
    { label: 'All', value: '' },
    ...[...brandsList].sort((a, b) => (a.label || '').localeCompare(b.label || '')),
  ];
  const rawLocations = state.locations.listForFilter || [];
  const locationsWithShortLabels = rawLocations.map(loc => ({
    ...loc,
    label: truncateLabel(loc.label),
  }));
  const sortedLocations = [
    { label: 'All', value: '' },
    ...[...locationsWithShortLabels].sort((a, b) => (a.label || '').localeCompare(b.label || '')),
  ];
  return {
    list: state.healthCheck.list,
    metrics: state.healthCheck.metrics,
    loading: state.healthCheck.loading,
    metricsLoading: state.healthCheck.metricsLoading,
    pagination: state.healthCheck.pagination,
    brands: sortedBrands,
    locations: sortedLocations,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchHealthChecks: params => dispatch(getHealthChecks(params)),
    fetchMetrics: params => dispatch(getHealthCheckMetrics(params)),
    fetchBrands: () => dispatch(getBrandsForFilter()),
    fetchLocationsForFilter: params => dispatch(getLocationsForFilter(params)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HealthChecksContainer);
